<template>
  <q-layout :container="container" :view="view">
    <slot></slot>
  </q-layout>
</template>

<script>
  export default {
    name: 'MiLayout',
    props: {
      container: {
        type: Boolean,
        required: false,
        default: false
      },
      view: {
        type: String,
        required: false,
        default: 'hHh lpr fFf'
      }
    }
  }
</script>
